import styled from "styled-components";
import {Paper, Dialog, TextField, Typography} from "@mui/material";

export const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0;
`;

export const FormContainer = styled.div`
  padding: 20px 0;
  width: 100%;
  flex-wrap: wrap;
  display: flex;
`;

export const DialogContainer = styled(Dialog)`
  & .MuiDialog-paper {
    padding: 20px;
  }
`;

export const DialogInput = styled(TextField)`
  & .MuiInputBase-root {
    margin-bottom: 15px;
  }
`;

export const ChargeAmount = styled(Typography)({
  fontSize: "84px",
  fontWeight: "bold",
  margin: "40px 0",
  textAlign: "center"
});

export const ChargeList = styled.div`
`;

export const ChargeItem = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  margin: 5px 0;
`;

export const ChargeTitle = styled.h4`
  margin: 5px 0;
  color: rgba(0, 0, 0, 0.7)
`;

export const ChargeItemAmount = styled.p`
  margin: 0 0 5px 0;
`
